import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPictoParticulierFormulaireEnLigne = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 80 80",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:#3b81c3;}.b{fill:none;stroke:#000;stroke-linejoin:round;stroke-width:0.8px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "201216__Icons_cl_medium_blue" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M10.26,20.57a2,2,0,0,1-.48-.05,2.27,2.27,0,1,1,.48.05Zm0-3.7A1.44,1.44,0,0,0,8.85,18,1.44,1.44,0,0,0,11,19.52a1.48,1.48,0,0,0,.63-.91,1.45,1.45,0,0,0-1.11-1.71h0A1.55,1.55,0,0,0,10.25,16.87Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M17.48,20.57a2.09,2.09,0,0,1-.49-.05,2.26,2.26,0,1,1,1-4.42h0a2.23,2.23,0,0,1,1.43,1,2.33,2.33,0,0,1,.31,1.71,2.26,2.26,0,0,1-1,1.42A2.23,2.23,0,0,1,17.48,20.57Zm0-3.7a1.48,1.48,0,0,0-.78.23,1.43,1.43,0,0,0-.62.91,1.38,1.38,0,0,0,.19,1.08,1.44,1.44,0,0,0,.91.63,1.42,1.42,0,0,0,1.08-.2,1.41,1.41,0,0,0,.63-.91,1.45,1.45,0,0,0-1.1-1.71h0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M24.64,20.57a2,2,0,0,1-.48-.05,2.27,2.27,0,1,1,.48.05Zm0-3.7a1.42,1.42,0,0,0-.78.23,1.44,1.44,0,1,0,1.08-.2h0A1.53,1.53,0,0,0,24.64,16.87Z"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M73.53,24.86H5.5a.41.41,0,0,1,0-.82h68a.41.41,0,1,1,0,.82Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M78.38,69.08H1.62A1.28,1.28,0,0,1,.33,67.79V12.21a1.28,1.28,0,0,1,1.29-1.29H78.36a1.29,1.29,0,1,1,0,2.57H2.91v53H77.09V12.75a1.29,1.29,0,0,1,2.58,0v55A1.28,1.28,0,0,1,78.38,69.08Z" }),
		/* @__PURE__ */ _jsx("rect", {
			className: "b",
			x: 5.67,
			y: 32.33,
			width: 67.29,
			height: 4.63
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "b",
			x: 5.67,
			y: 39.87,
			width: 67.29,
			height: 4.63
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "b",
			x: 5.67,
			y: 46.69,
			width: 67.29,
			height: 4.63
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: 50.18,
			y: 56.63,
			width: 22.79,
			height: 4.63,
			rx: 1.36
		})
	]
});
export default SvgPictoParticulierFormulaireEnLigne;
